import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getXochipilliDatasetDetails} from "~/workspaceConfig/hostedPages/dashboard/-api";
import {OTTOKART_GA4_LOGINS_DATASET_ID, TUFFEX_DASHBOARD_DATASET_ID} from "~/workspaceConfig/hostedPages/dashboard/-dashboardConfig/ottokartDashboardConfig";
import {getDefaultThisMonthDateRangeIsoBounds} from "~/utilities/defaultDateRange";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/",
)({
    loader: async ({context}) => {
        const {
            intellsysBaseUrl,
            workspace,
            authenticationStatus: {accessToken},
        } = context;

        const [datasetResult, ga4DatasetResult] = await Promise.all([
            getXochipilliDatasetDetails(TUFFEX_DASHBOARD_DATASET_ID, intellsysBaseUrl, accessToken, workspace.id, context.queryClient),
            getXochipilliDatasetDetails(OTTOKART_GA4_LOGINS_DATASET_ID, intellsysBaseUrl, accessToken, workspace.id, context.queryClient),
        ]);
        if (datasetResult.success !== true) {
            throw datasetResult.error;
        }
        if (ga4DatasetResult.success !== true) {
            throw ga4DatasetResult.error;
        }

        const {start, end} = getDefaultThisMonthDateRangeIsoBounds();

        return {
            dataset: datasetResult.data,
            ga4Dataset: ga4DatasetResult.data,
            defaultRange: {start: start, end: end},
            workspaceUser: context.currentWorkspaceUser,
            platformUser: context.profileStatus.platformUser,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
